/**
 * Use Cloudfront CDN to deliver our DatoCMS assets.
 * This is used for larger videos to save money on monthly bandwidth
 */
export function convertDatoCmsAssetUrlToCloudfrontUrl(datoCmsAssetUrl: string) {
  return datoCmsAssetUrl.replace(
    "https://www.datocms-assets.com/15671/",
    "https://d1d5yi2hyph3ss.cloudfront.net/"
  );
}
